import { isEmptyValue } from '@/utils/utils';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'hierarchy-form',
    components: {
    },
})

export default class HierarchyForm extends Vue {

    @Prop({ default: {} })
    public userData: any;

    private selectedBlock: any = 'US';

    private hirarchyOption: any = {
        IND: 1,
        US: 2,
        CUSTOM: null,
    };

    private groupHierarchy: any = {
        hiearchy_id: 1,
    };

    private usHierarchy: any = [
        { id: 1, name: 'Country', sequence: 1, key: 'country' },
        { id: 2, name: 'State', sequence: 2, key: 'state' },
        { id: 3, name: 'School District', sequence: 3, key: 'school_district' },
        { id: 4, name: 'School', sequence: 4, key: 'school' },
        { id: 5, name: 'Classes', sequence: 5, key: 'classes' },
    ];

    private indianHierarchy: any = [
        { id: 1, name: 'Country', sequence: 1, key: 'country' },
        { id: 2, name: 'State', sequence: 2, key: 'state' },
        { id: 3, name: 'District', sequence: 3, key: 'district' },
        { id: 4, name: 'Block', sequence: 4, key: 'block' },
        { id: 5, name: 'Cluster', sequence: 5, key: 'cluster' },
        { id: 6, name: 'Classes', sequence: 6, key: 'classes' },
    ];

    private customHierarchyRaw: any = [
        { id: 1, name: 'Country', sequence: 1, key: 'country' },
        { id: 2, name: 'State', sequence: 2, key: 'state' },
        { id: 3, name: 'School District', sequence: 3, key: 'school_district' },
        { id: 4, name: 'District', sequence: 4, key: 'district' },
        { id: 5, name: 'Block', sequence: 5, key: 'block' },
        { id: 6, name: 'Cluster', sequence: 6, key: 'cluster' },
        { id: 7, name: 'Classes', sequence: 7, key: 'classes' },
    ];

    private onBackTolist(key: any) {
        this.$emit('onChangeComponent', key);
    }

    private goNext(key: any) {
        let selected = this.usHierarchy;
        switch (this.selectedBlock) {
            case 'US':
                selected = this.usHierarchy;
                break;
            case 'IND':
                selected = this.indianHierarchy;
                break;
            case 'CUSTOM':
                selected = this.customHierarchyRaw;
                break;
        }
        this.selectedHierarchyFlow(this.selectedBlock, selected);
        this.userData.group_hierarchy = this.groupHierarchy;
        this.$emit('onChangeComponent', key);
    }

    private onSelectBlock(block: any) {
        this.selectedBlock = block;
    }

    private selectedHierarchyFlow(selectedBlock: any, selected: any) {
        this.groupHierarchy.hiearchy_id = this.hirarchyOption[selectedBlock];
        if (this.groupHierarchy && isEmptyValue(this.groupHierarchy.hiearchy_id)) {
            const empty: any = {};
            for (const iterator of selected) {
                if (iterator.checked) {
                    empty[iterator.key] = iterator.name;
                }
            }
            this.groupHierarchy.custom_hierarchy = empty;
        }
    }
}
